import MediaAnalysisBill from './mediaAnalysisBill';

export default MediaAnalysisBill;
